import ActionTypes from '@ziynx/action-types';

type AdminActions = {
  type: string,
}

const initialState = {
  results: [],
  page: 0,
  pageSize: 25,
  isLastPage: false,
  fetching: false,
};

export default function reduceNILList(state = initialState, action: AdminActions) {
  if (!action.type) {
    return state;
  }

  let deletedId;
  let filteredResults = state?.results;
  if (action?.id && action?.type === ActionTypes.NIL.delete.SUCCESS) {
    deletedId = action?.id;
    filteredResults = state?.results?.filter((item) => item?._id !== deletedId);
  }

  switch (action.type) {
  case ActionTypes.NIL.getAll.START:
    return {
      ...state,
      fetching: true,
      ...(action?.response || {}),
    };

  case ActionTypes.NIL.getAll.SUCCESS:
    return {
      ...state,
      fetching: false,
      ...(action?.response || {}),
      results: action?.response?.page > 0
        ? (state?.results ?? []).concat(action?.response?.results ?? [])
        : action?.response?.results,
    };

  case ActionTypes.NIL.getAll.ERROR:
    return {
      ...state,
      fetching: false,
      ...(action?.response || {}),
    };

  case ActionTypes.NIL.delete.SUCCESS:
    return {
      ...state,
      results: filteredResults,
    };

  default:
    return state;
  }
}
